(() => {
  let dispose = () => {};
  function initialize() {
    dispose();
    const root = document.querySelector('.gredie-site');
    if (!root) return;
    const controller = new AbortController();
    const options = { passive: true, signal: controller.signal };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 981px)');
    const header = root.querySelector('[data-header]');
    const button = root.querySelector('[data-motion-toggle]');
    const parallax = [...root.querySelectorAll('[data-parallax]')];
    const photos = [...root.querySelectorAll('[data-generation-motion]')];
    let paused = false;
    let frame = 0;
    const update = () => {
      frame = 0;
      const disabled = paused || reduced.matches || root.dataset.motionEnabled === 'false';
      root.classList.toggle('motion-paused', disabled);
      header?.classList.toggle('scrolled', window.scrollY > 30);
      for (const el of parallax) {
        if (disabled || !desktop.matches) { el.style.transform = ''; continue; }
        const rect = el.getBoundingClientRect();
        const offset = Math.max(-18, Math.min(18, (rect.top + rect.height / 2 - innerHeight / 2) * -.035));
        el.style.transform = 'translate3d(0,' + offset + 'px,0)';
      }
      for (const el of photos) {
        const rect = el.getBoundingClientRect();
        const offset = disabled ? 0 : Math.max(-7, Math.min(7, (rect.top + rect.height / 2 - innerHeight / 2) * -.025));
        el.style.setProperty('--image-shift', offset + 'px');
      }
      if (button) {
        button.hidden = reduced.matches || root.dataset.motionEnabled === 'false';
        button.setAttribute('aria-pressed', String(paused));
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    button?.addEventListener('click', () => { paused = !paused; update(); }, { signal: controller.signal });
    window.addEventListener('scroll', schedule, options);
    window.addEventListener('resize', schedule, options);
    reduced.addEventListener('change', schedule, { signal: controller.signal });
    dispose = () => { controller.abort(); cancelAnimationFrame(frame); };
    update();
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => dispose());
})();
